import { PaletteMode } from "@mui/material"
import { createSlice } from "@reduxjs/toolkit"
import { useSelector } from "react-redux"

import { RootState } from "~/store/store"

export interface CommonState {
  lang: string | undefined
  themeMode: PaletteMode
  rtlLanguages: string[]
  isRtl: boolean
}

const initialState: CommonState = {
  rtlLanguages: ["fa", "ar"],
  lang: "fa",
  themeMode: "light",
  get isRtl() {
    return this.rtlLanguages.includes(this.lang || "")
  },
  set isRtl(rtl) {
    this.isRtl = rtl
  },
}

export const CommonSlice = createSlice({
  name: "common",
  initialState,
  reducers: {
    setLang: (state, action) => {
      state.lang = action.payload
      state.isRtl = state.rtlLanguages.includes(state.lang || "")
    },
    changeThemeMode: (state) => {
      state.themeMode = state.themeMode === "light" ? "dark" : "light"
    },
  },
})

export const useCommon = (): CommonState =>
  useSelector((state: RootState) => state.common)

export const { setLang, changeThemeMode } = CommonSlice.actions

export default CommonSlice.reducer
